// Standard Norwegian award-letter (tildelingsbrev) boilerplate. These are formal procurement-law
// texts rendered verbatim in the letters, so they are kept as Norwegian constants rather than i18n keys.
// The computed standstill (karens) expiry date is deferred — the clause references the period generically.

export const winnerIntro = (eventTitle: string): string =>
  `Vi viser til Deres tilbud i konkurransen om ${eventTitle}.\n\n` +
  `På vegne av oppdragsgiver meddeles herved at kontrakten vil bli inngått med Deres firma.`;

export const rejectionIntro = (eventTitle: string, winnerName: string): string =>
  `Vi viser til Deres tilbud i konkurransen om ${eventTitle}.\n\n` +
  `På vegne av oppdragsgiver meddeles herved at kontrakten vil bli inngått med ${winnerName}.`;

export const KARENS_INFO =
  "Det gjelder en karensperiode regnet fra denne meddelelsen er sendt, jf. anskaffelsesforskriften " +
  "§ 25-2. Kontrakten vil ikke bli inngått før karensperioden er utløpt.";

export const KLAGE_INFO =
  "Eventuell klage på tildelingsbeslutningen kan rettes til oppdragsgiver eller til Klagenemnda for " +
  "offentlige anskaffelser (KOFA), Postboks 511 Sentrum, 5805 Bergen, eller per e-post post@kofa.no.";

export const SIGN_OFF = "Med vennlig hilsen,\noppdragsgiver";
